import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import arrow from "./assets/icons/arrow.svg";

import classes from "./Opener2.module.css";
import { testUrl } from "../BaseData";

export const Opener2 = () => {
    const { t, i18n } = useTranslation();
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Stacked animation state
    const [activeIndex, setActiveIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const fetchNewsData = axios.get(
            testUrl + "/api/newsthree/"
        );

        Promise.all([fetchNewsData])
            .then(([newsResponse]) => {
                const news_data = newsResponse.data || [];
                if (Array.isArray(news_data)) {
                    setNewsData(news_data);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [t]);

    const next = useCallback(() => {
        if (isAnimating || newsData.length < 2) return;
        setIsAnimating(true);
        setActiveIndex((prev) => (prev + 1) % newsData.length);

        setTimeout(() => {
            setIsAnimating(false);
        }, 250);
    }, [isAnimating, newsData.length]);

    // Auto-advance every 3.5s
    useEffect(() => {
        if (newsData.length < 2) return;
        const timer = setInterval(next, 3500);
        return () => clearInterval(timer);
    }, [next, newsData.length]);

    return (
        <div id="opener" className={classes.wrapper}>
            <video
                autoPlay
                muted
                loop
                playsInline
                className={classes["video-background"]}
            >
                <source src="/video/bg2.mp4" type="video/mp4" />
            </video>
            <div className={classes.mainContainer}>
                {/* Hero Section */}
                <div data-aos="fade-up" className={classes.container}>
                    <h1 className={classes.title}>
                        <span className="span_bluem">
                            {t("openerTitleSpan")}
                        </span>
                    </h1>
                    <br />
                    <p className={classes.descr}>
                        {t("openerDescr")}
                    </p>
                    <div className={classes["flex"]}>
                        <a href="https://qabul.renessans-edu.uz/" target="_blank" rel="noopener noreferrer">
                            <button className={classes["btn1"]}>
                                {t("Ariza topshirish")}
                                <img src={arrow} alt="arrow" />
                            </button>
                        </a>
                        <a href="https://www.greenwich-renessans.com" target="_blank" rel="noopener noreferrer">
                            <button className={`${classes["btn1"]} ${classes["btnBlue"]}`}>
                                <div style={{ textAlign: 'center' }}>
                                    {t(`greenwichApply`).split('|').map((line, index) => (
                                        <div key={index}>{line}</div>
                                    ))}
                                </div>
                                <img src={arrow} alt="arrow" />
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Opener2;
